module.exports = __webpack_public_path__ + "static/media/track.eecf5fe7.png";